export default {
    USER_LOGIN: "USER_LOGIN",
    USER_SIGNUP: "USER_SIGNUP",
    COMPANY_REGISTER: "COMPANY_REGISTER"
};